export const TEXT_MAX_LINES = 5;
export const TEXT_MAX_LENGTH = 100;
export const PLACES_API_KEY = "AIzaSyB9Xy0guUT63H76EvanaEf2EHGrkrFA4iU";
